import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "admin-view-jira-page" }
const _hoisted_2 = { class: "full-wrapper" }
const _hoisted_3 = { class: "main-custom-row" }
const _hoisted_4 = { class: "main-left" }
const _hoisted_5 = { class: "view-jira-ticket-section" }
const _hoisted_6 = { class: "jira-breadcrumb-box" }
const _hoisted_7 = { href: "javascript:void(0);" }
const _hoisted_8 = { class: "jira-ticket-title" }
const _hoisted_9 = { class: "jira-ticket-tabs" }
const _hoisted_10 = { class: "jira-ticket-tabs-top" }
const _hoisted_11 = {
  class: "nav",
  id: "nav-tab",
  role: "tablist"
}
const _hoisted_12 = { class: "jira-ticket-tabs-btm" }
const _hoisted_13 = { class: "jira-ticket-tabs-btm-left" }
const _hoisted_14 = {
  class: "tab-content",
  id: "nav-tabContent"
}
const _hoisted_15 = { class: "jira-details-tabs-content" }
const _hoisted_16 = { class: "jira-details-white-bg jira-details-top-info" }
const _hoisted_17 = { class: "span-label" }
const _hoisted_18 = { class: "span-value" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "span-label" }
const _hoisted_21 = { class: "span-value" }
const _hoisted_22 = { class: "span-label" }
const _hoisted_23 = { class: "span-value" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "span-label" }
const _hoisted_26 = { class: "span-value" }
const _hoisted_27 = { class: "span-label" }
const _hoisted_28 = { class: "span-value" }
const _hoisted_29 = { class: "span-label" }
const _hoisted_30 = { class: "span-value" }
const _hoisted_31 = { class: "span-label" }
const _hoisted_32 = { class: "span-value" }
const _hoisted_33 = { class: "jira-details-white-bg jira-details-description-box" }
const _hoisted_34 = { class: "jira-ticket-description-box" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { key: 1 }
const _hoisted_37 = {
  key: 0,
  class: "jira-details-white-bg jira-details-attachment-box"
}
const _hoisted_38 = { class: "jira-ticket-attachment-box" }
const _hoisted_39 = { class: "attachments-grid" }
const _hoisted_40 = { class: "attachment-header" }
const _hoisted_41 = { class: "attachment-filename" }
const _hoisted_42 = { class: "attachment-size" }
const _hoisted_43 = {
  key: 0,
  class: "attachment-media"
}
const _hoisted_44 = ["src", "alt", "onClick"]
const _hoisted_45 = {
  key: 1,
  class: "attachment-media"
}
const _hoisted_46 = {
  controls: "",
  class: "attachment-video",
  preload: "metadata"
}
const _hoisted_47 = ["src", "type"]
const _hoisted_48 = {
  key: 2,
  class: "attachment-file"
}
const _hoisted_49 = ["href"]
const _hoisted_50 = { class: "attachment-meta" }
const _hoisted_51 = { class: "attachment-author" }
const _hoisted_52 = { class: "attachment-date" }
const _hoisted_53 = { class: "jira-comments-tabs-content" }
const _hoisted_54 = { class: "jira-details-white-bg jira-ticket-comments" }
const _hoisted_55 = { class: "jira-ticket-comments-logs-top" }
const _hoisted_56 = { class: "add-new-c-l-form" }
const _hoisted_57 = { class: "add-new-c-l-form-input" }
const _hoisted_58 = { class: "add-new-c-l-form-btns" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = { class: "add-new-c-l-form" }
const _hoisted_61 = { class: "add-new-c-l-form-input" }
const _hoisted_62 = { class: "add-new-c-l-form-btns" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { class: "jira-comments-logs-list-section" }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { class: "jira-comments-logs-list-top" }
const _hoisted_67 = { class: "jira-comments-logs-list-top-left" }
const _hoisted_68 = { class: "jira-comments-logs-list-img" }
const _hoisted_69 = ["src"]
const _hoisted_70 = { class: "jira-comments-logs-list-name" }
const _hoisted_71 = { href: "#" }
const _hoisted_72 = { class: "jira-comments-logs-list-type" }
const _hoisted_73 = { class: "jira-comments-logs-list-time" }
const _hoisted_74 = { class: "jira-comments-logs-list-actions" }
const _hoisted_75 = ["onClick", "disabled"]
const _hoisted_76 = ["onClick", "disabled"]
const _hoisted_77 = { class: "jira-comments-logs-list-text" }
const _hoisted_78 = ["innerHTML"]
const _hoisted_79 = {
  key: 1,
  class: "jira-comments-logs-list"
}
const _hoisted_80 = { class: "jira-comments-logs-load-more" }
const _hoisted_81 = { class: "jira-load-more-btn" }
const _hoisted_82 = { class: "jira-work-log-tabs-content" }
const _hoisted_83 = { class: "jira-details-white-bg jira-ticket-logs" }
const _hoisted_84 = { class: "jira-ticket-comments-logs-top" }
const _hoisted_85 = { class: "add-new-c-l-form" }
const _hoisted_86 = { class: "add-new-c-l-form-input-box" }
const _hoisted_87 = { class: "add-new-c-l-form-input" }
const _hoisted_88 = { class: "add-new-c-l-form-input-with-txt" }
const _hoisted_89 = { class: "add-new-c-l-form-input-box" }
const _hoisted_90 = { class: "add-new-c-l-form-input" }
const _hoisted_91 = { class: "admin-date-input" }
const _hoisted_92 = { class: "add-new-c-l-form-input-box" }
const _hoisted_93 = { class: "add-new-c-l-form-input" }
const _hoisted_94 = { class: "add-new-c-l-form-btns" }
const _hoisted_95 = ["disabled"]
const _hoisted_96 = { class: "add-new-c-l-form" }
const _hoisted_97 = { class: "add-new-c-l-form-input-box" }
const _hoisted_98 = { class: "add-new-c-l-form-input" }
const _hoisted_99 = { class: "add-new-c-l-form-input-with-txt" }
const _hoisted_100 = { class: "add-new-c-l-form-input-box" }
const _hoisted_101 = { class: "add-new-c-l-form-input" }
const _hoisted_102 = { class: "admin-date-input" }
const _hoisted_103 = { class: "add-new-c-l-form-input-box" }
const _hoisted_104 = { class: "add-new-c-l-form-input" }
const _hoisted_105 = { class: "add-new-c-l-form-btns" }
const _hoisted_106 = ["disabled"]
const _hoisted_107 = { class: "jira-comments-logs-list-section" }
const _hoisted_108 = { key: 0 }
const _hoisted_109 = { class: "jira-comments-logs-list-top" }
const _hoisted_110 = { class: "jira-comments-logs-list-top-left" }
const _hoisted_111 = { class: "jira-comments-logs-list-img" }
const _hoisted_112 = ["src"]
const _hoisted_113 = { class: "jira-comments-logs-list-name" }
const _hoisted_114 = { href: "#" }
const _hoisted_115 = { class: "jira-comments-logs-list-type" }
const _hoisted_116 = { class: "jira-comments-logs-list-time" }
const _hoisted_117 = { class: "jira-comments-logs-list-actions" }
const _hoisted_118 = ["onClick", "disabled"]
const _hoisted_119 = ["onClick", "disabled"]
const _hoisted_120 = { class: "jira-time-spent" }
const _hoisted_121 = { class: "jira-comments-logs-list-text" }
const _hoisted_122 = ["innerHTML"]
const _hoisted_123 = { key: 1 }
const _hoisted_124 = {
  key: 1,
  class: "jira-comments-logs-list"
}
const _hoisted_125 = { class: "jira-comments-logs-load-more" }
const _hoisted_126 = { class: "jira-load-more-btn" }
const _hoisted_127 = { class: "jira-ticket-tabs-btm-right" }
const _hoisted_128 = { class: "sm-people-assignees-reporter" }
const _hoisted_129 = { class: "people-assignees-box" }
const _hoisted_130 = { class: "people-assignees-reporter-box" }
const _hoisted_131 = { class: "people-assignees-reporter-img" }
const _hoisted_132 = ["src"]
const _hoisted_133 = { class: "people-assignees-reporter-name" }
const _hoisted_134 = { class: "people-reporter-box" }
const _hoisted_135 = { class: "people-assignees-reporter-box" }
const _hoisted_136 = { class: "people-assignees-reporter-img" }
const _hoisted_137 = ["src"]
const _hoisted_138 = { class: "people-assignees-reporter-name" }
const _hoisted_139 = { class: "sm-jira-ticket-date-box" }
const _hoisted_140 = { class: "sm-jira-ticket-time-tracking-box" }
const _hoisted_141 = { class: "jira-time-track-status-box" }
const _hoisted_142 = { class: "jira-time-track-status-box-top" }
const _hoisted_143 = { class: "jira-time-track-status-box-top-time" }
const _hoisted_144 = { class: "jira-time-track-status-box-progress" }
const _hoisted_145 = { class: "jira-time-track-status-box" }
const _hoisted_146 = { class: "jira-time-track-status-box-top" }
const _hoisted_147 = { class: "jira-time-track-status-box-top-time" }
const _hoisted_148 = { class: "jira-time-track-status-box-progress" }
const _hoisted_149 = { class: "jira-time-track-status-box" }
const _hoisted_150 = { class: "jira-time-track-status-box-top" }
const _hoisted_151 = { class: "jira-time-track-status-box-top-time" }
const _hoisted_152 = { class: "jira-time-track-status-box-progress" }
const _hoisted_153 = { class: "main-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_Issues = _resolveComponent("Issues")!
  const _component_Activity = _resolveComponent("Activity")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.issueDetail.fields?.project?.name || "Project"), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.issueDetail.key), 1)
            ]),
            _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.issueDetail.fields?.summary || "Loading..."), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'details' }]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'details')),
                    type: "button",
                    role: "tab"
                  }, _toDisplayString("Details"), 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'comments' }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'comments')),
                    type: "button",
                    role: "tab"
                  }, _toDisplayString("Comments"), 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'worklog' }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'worklog')),
                    type: "button",
                    role: "tab"
                  }, _toDisplayString("Work Log"), 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["tab-pane fade", { 'show active': _ctx.activeTab === 'details' }]),
                      id: "jiraTabOne",
                      role: "tabpanel",
                      "aria-labelledby": "jira-tab-one"
                    }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.constants.TYPE_LABEL) + " :", 1),
                              _createElementVNode("span", _hoisted_18, [
                                _createElementVNode("img", {
                                  src: _ctx.issueDetail.fields?.issuetype?.iconUrl || '@/assets/lems-v1/images/viewavatar.svg',
                                  alt: ""
                                }, null, 8, _hoisted_19),
                                _createTextVNode(" " + _toDisplayString(_ctx.issueDetail.fields?.issuetype?.name || "Unknown"), 1)
                              ])
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.constants.STATUS_LABEL) + " :", 1),
                              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.issueDetail.fields?.status?.name || "Unknown"), 1)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.constants.PRIORITY_LABEL) + " :", 1),
                              _createElementVNode("span", _hoisted_23, [
                                _createElementVNode("img", {
                                  src: _ctx.issueDetail.fields?.priority?.iconUrl || '@/assets/lems-v1/images/major.svg',
                                  alt: ""
                                }, null, 8, _hoisted_24),
                                _createTextVNode(" " + _toDisplayString(_ctx.issueDetail.fields?.priority?.name || "Unknown"), 1)
                              ])
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.constants.AFFECTS_VERSION_LABEL) + " :", 1),
                              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.getVersions(_ctx.issueDetail.fields?.versions)), 1)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.constants.LABELS_LABEL) + " :", 1),
                              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.getLabels(_ctx.issueDetail.fields?.labels)), 1)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.constants.FIX_VERSION_LABEL) + " :", 1),
                              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.getVersions(_ctx.issueDetail.fields?.fixVersions)), 1)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.constants.ENVIRONMENT_LABEL) + " :", 1),
                              _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.issueDetail.fields?.environment || "None"), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.constants.DESCRIPTION_TEXT), 1),
                          _createElementVNode("div", _hoisted_34, [
                            (_ctx.issueDetail.fields?.description)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  innerHTML: _ctx.issueDetail.fields.description
                                }, null, 8, _hoisted_35))
                              : (_openBlock(), _createElementBlock("p", _hoisted_36, "No description provided."))
                          ])
                        ]),
                        (_ctx.issueDetail.attachments && _ctx.issueDetail.attachments.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.constants.ATTACHMENTS_LABEL), 1),
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.issueDetail.attachments, (attachment) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: attachment.id,
                                      class: "attachment-item"
                                    }, [
                                      _createElementVNode("div", _hoisted_40, [
                                        _createElementVNode("span", _hoisted_41, _toDisplayString(attachment.filename), 1),
                                        _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.formatFileSize(attachment.size)), 1)
                                      ]),
                                      (_ctx.isImageAttachment(attachment))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                            _createElementVNode("img", {
                                              src: attachment.content,
                                              alt: attachment.filename,
                                              class: "attachment-image",
                                              onClick: ($event: any) => (_ctx.openImageModal(attachment))
                                            }, null, 8, _hoisted_44)
                                          ]))
                                        : (_ctx.isVideoAttachment(attachment))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                              _createElementVNode("video", _hoisted_46, [
                                                _createElementVNode("source", {
                                                  src: attachment.content,
                                                  type: attachment.mimeType
                                                }, null, 8, _hoisted_47),
                                                _cache[21] || (_cache[21] = _createTextVNode(" Your browser does not support the video tag. ", -1))
                                              ])
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "file-icon" }, [
                                                _createElementVNode("i", { class: "fas fa-file" })
                                              ], -1)),
                                              _createElementVNode("a", {
                                                href: attachment.content,
                                                target: "_blank",
                                                class: "file-download-link"
                                              }, " Download " + _toDisplayString(attachment.filename), 9, _hoisted_49)
                                            ])),
                                      _createElementVNode("div", _hoisted_50, [
                                        _createElementVNode("span", _hoisted_51, _toDisplayString(attachment.author?.displayName), 1),
                                        _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.formatDate(attachment.created)), 1)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["tab-pane fade", { 'show active': _ctx.activeTab === 'comments' }]),
                      id: "jiraTabTwo",
                      role: "tabpanel",
                      "aria-labelledby": "jira-tab-two"
                    }, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.constants.COMMENTS_TEXT), 1),
                            _createElementVNode("button", {
                              class: "jira-add-new--btn jira-add-new-btn-comment",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showCommentFormHandler && _ctx.showCommentFormHandler(...args)))
                            }, _toDisplayString(_ctx.constants.ADD_COMMENT_BUTTON), 1)
                          ]),
                          _createElementVNode("div", {
                            style: _normalizeStyle({ display: _ctx.showCommentForm ? 'block' : 'none' }),
                            class: "add-new-c-l-form-section add-new-comment-form-section"
                          }, [
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newComment) = $event)),
                                  placeholder: "Add a comment...",
                                  rows: "4",
                                  style: {"width":"100%","padding":"10px","border":"1px solid #ddd","border-radius":"4px","resize":"vertical"}
                                }, null, 512), [
                                  [_vModelText, _ctx.newComment]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("button", {
                                  class: "v1-button-outline",
                                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addComment && _ctx.addComment(...args))),
                                  disabled: _ctx.commentLoading
                                }, _toDisplayString(_ctx.commentLoading
                                      ? "Adding..."
                                      : _ctx.constants.ADD_BUTTON), 9, _hoisted_59),
                                _createElementVNode("button", {
                                  class: "v1-button-outline-black",
                                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.hideCommentFormHandler && _ctx.hideCommentFormHandler(...args)))
                                }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                              ])
                            ])
                          ], 4),
                          _createElementVNode("div", {
                            style: _normalizeStyle({ display: _ctx.showEditCommentForm ? 'block' : 'none' }),
                            class: "add-new-c-l-form-section add-new-comment-form-section"
                          }, [
                            _createElementVNode("div", _hoisted_60, [
                              _cache[23] || (_cache[23] = _createElementVNode("h3", { style: {"margin-bottom":"20px","color":"#333"} }, "Edit Comment", -1)),
                              _createElementVNode("div", _hoisted_61, [
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editComment.body) = $event)),
                                  placeholder: "Edit your comment...",
                                  rows: "4",
                                  style: {"width":"100%","padding":"10px","border":"1px solid #ddd","border-radius":"4px","resize":"vertical"}
                                }, null, 512), [
                                  [_vModelText, _ctx.editComment.body]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("button", {
                                  class: "v1-button-outline",
                                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.updateComment && _ctx.updateComment(...args))),
                                  disabled: _ctx.editCommentLoading
                                }, _toDisplayString(_ctx.editCommentLoading
                                      ? "Updating..."
                                      : "Update Comment"), 9, _hoisted_63),
                                _createElementVNode("button", {
                                  class: "v1-button-outline-black",
                                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.hideEditCommentFormHandler && _ctx.hideEditCommentFormHandler(...args)))
                                }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                              ])
                            ])
                          ], 4),
                          _createElementVNode("div", _hoisted_64, [
                            (_ctx.issueDetail.comments && _ctx.issueDetail.comments.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.issueDetail.comments, (comment) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: comment.id,
                                      class: "jira-comments-logs-list"
                                    }, [
                                      _createElementVNode("div", _hoisted_66, [
                                        _createElementVNode("div", _hoisted_67, [
                                          _createElementVNode("div", _hoisted_68, [
                                            _createElementVNode("img", {
                                              src: comment.author?.avatarUrls?.['48x48'] || '@/assets/lems-v1/images/team-members/binod.jpg',
                                              alt: ""
                                            }, null, 8, _hoisted_69)
                                          ]),
                                          _createElementVNode("div", _hoisted_70, [
                                            _createElementVNode("a", _hoisted_71, _toDisplayString(comment.author?.displayName || "Unknown"), 1)
                                          ]),
                                          _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.constants.ADDED_A_COMMENT_TEXT), 1),
                                          _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.formatDate(comment.created)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_74, [
                                          _createElementVNode("ul", null, [
                                            _createElementVNode("li", null, [
                                              _createElementVNode("button", {
                                                class: "jira-edit-comment-btn",
                                                onClick: ($event: any) => (_ctx.editCommentHandler(comment)),
                                                disabled: _ctx.editCommentLoading || _ctx.deleteCommentLoading,
                                                title: "Edit Comment"
                                              }, null, 8, _hoisted_75)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _createElementVNode("button", {
                                                class: "jira-delete-comment-btn",
                                                onClick: ($event: any) => (_ctx.deleteCommentHandler(comment)),
                                                disabled: _ctx.editCommentLoading || _ctx.deleteCommentLoading,
                                                title: "Delete Comment"
                                              }, null, 8, _hoisted_76)
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_77, [
                                        _createElementVNode("div", {
                                          innerHTML: _ctx.replaceJiraMarkup(comment.body)
                                        }, null, 8, _hoisted_78)
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_79, [...(_cache[24] || (_cache[24] = [
                                  _createElementVNode("div", { class: "jira-comments-logs-list-text" }, [
                                    _createElementVNode("p", null, "No comments yet.")
                                  ], -1)
                                ]))]))
                          ]),
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("button", _hoisted_81, _toDisplayString(_ctx.constants.LOAD_MORE_BUTTON), 1)
                          ])
                        ])
                      ])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["tab-pane fade", { 'show active': _ctx.activeTab === 'worklog' }]),
                      id: "jiraTabThree",
                      role: "tabpanel",
                      "aria-labelledby": "jira-tab-three"
                    }, [
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", _hoisted_84, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.constants.WORK_LOG_TEXT), 1),
                            _createElementVNode("button", {
                              class: "jira-add-new--btn jira-add-new-btn-logs",
                              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showWorklogFormHandler && _ctx.showWorklogFormHandler(...args)))
                            }, _toDisplayString(_ctx.constants.LOG_WORK_BUTTON), 1)
                          ]),
                          _createElementVNode("div", {
                            class: "add-new-c-l-form-section add-new-logs-form-section",
                            style: _normalizeStyle({ display: _ctx.showWorklogForm ? 'block' : 'none' })
                          }, [
                            _createElementVNode("div", _hoisted_85, [
                              _createElementVNode("div", _hoisted_86, [
                                _createElementVNode("label", null, [
                                  _createTextVNode(_toDisplayString(_ctx.constants.TIME_SPENT_LABEL) + " ", 1),
                                  _cache[25] || (_cache[25] = _createElementVNode("i", null, "*", -1))
                                ]),
                                _createElementVNode("div", _hoisted_87, [
                                  _createElementVNode("div", _hoisted_88, [
                                    _withDirectives(_createElementVNode("input", {
                                      id: "timeSpentInput",
                                      type: "text",
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newWorklog.timeSpent) = $event)),
                                      placeholder: ""
                                    }, null, 512), [
                                      [_vModelText, _ctx.newWorklog.timeSpent]
                                    ]),
                                    _cache[26] || (_cache[26] = _createElementVNode("span", null, "(eg. 3w 4d 12h)", -1))
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_89, [
                                _createElementVNode("label", null, [
                                  _createTextVNode(_toDisplayString(_ctx.constants.DATE_STARTED_LABEL) + " ", 1),
                                  _cache[27] || (_cache[27] = _createElementVNode("i", null, "*", -1))
                                ]),
                                _createElementVNode("div", _hoisted_90, [
                                  _createElementVNode("div", _hoisted_91, [
                                    _createVNode(_component_datepicker, {
                                      modelValue: _ctx.newWorklog.started,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newWorklog.started) = $event)),
                                      id: "dateStartedInput",
                                      class: "date-icon",
                                      placeholder: "Select Date",
                                      "max-date": new Date(),
                                      "enable-time-picker": false,
                                      format: "yyyy-MM-dd"
                                    }, null, 8, ["modelValue", "max-date"])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_92, [
                                _createElementVNode("label", null, _toDisplayString(_ctx.constants.WORK_DESCRIPTION_LABEL), 1),
                                _createElementVNode("div", _hoisted_93, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newWorklog.comment) = $event)),
                                    placeholder: "Add work description...",
                                    rows: "3",
                                    style: {"width":"100%","padding":"10px","border":"1px solid #ddd","border-radius":"4px","resize":"vertical"}
                                  }, null, 512), [
                                    [_vModelText, _ctx.newWorklog.comment]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_94, [
                                _createElementVNode("button", {
                                  class: "v1-button-outline",
                                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.addWorklog && _ctx.addWorklog(...args))),
                                  disabled: _ctx.worklogLoading
                                }, _toDisplayString(_ctx.worklogLoading
                                      ? "Adding..."
                                      : _ctx.constants.ADD_BUTTON), 9, _hoisted_95),
                                _createElementVNode("button", {
                                  class: "v1-button-outline-black",
                                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.hideWorklogFormHandler && _ctx.hideWorklogFormHandler(...args)))
                                }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                              ])
                            ])
                          ], 4),
                          _createElementVNode("div", {
                            class: "add-new-c-l-form-section add-new-logs-form-section",
                            style: _normalizeStyle({ display: _ctx.showEditWorklogForm ? 'block' : 'none' })
                          }, [
                            _createElementVNode("div", _hoisted_96, [
                              _cache[31] || (_cache[31] = _createElementVNode("h3", { style: {"margin-bottom":"20px","color":"#333"} }, "Edit Work Log", -1)),
                              _createElementVNode("div", _hoisted_97, [
                                _createElementVNode("label", null, [
                                  _createTextVNode(_toDisplayString(_ctx.constants.TIME_SPENT_LABEL) + " ", 1),
                                  _cache[28] || (_cache[28] = _createElementVNode("i", null, "*", -1))
                                ]),
                                _createElementVNode("div", _hoisted_98, [
                                  _createElementVNode("div", _hoisted_99, [
                                    _withDirectives(_createElementVNode("input", {
                                      id: "editTimeSpentInput",
                                      type: "text",
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.editWorklog.timeSpent) = $event)),
                                      placeholder: ""
                                    }, null, 512), [
                                      [_vModelText, _ctx.editWorklog.timeSpent]
                                    ]),
                                    _cache[29] || (_cache[29] = _createElementVNode("span", null, "(eg. 3w 4d 12h)", -1))
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_100, [
                                _createElementVNode("label", null, [
                                  _createTextVNode(_toDisplayString(_ctx.constants.DATE_STARTED_LABEL) + " ", 1),
                                  _cache[30] || (_cache[30] = _createElementVNode("i", null, "*", -1))
                                ]),
                                _createElementVNode("div", _hoisted_101, [
                                  _createElementVNode("div", _hoisted_102, [
                                    _createVNode(_component_datepicker, {
                                      modelValue: _ctx.editWorklog.started,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.editWorklog.started) = $event)),
                                      id: "editDateStartedInput",
                                      class: "date-icon",
                                      placeholder: "Select Date",
                                      "max-date": new Date(),
                                      "enable-time-picker": false,
                                      format: "yyyy-MM-dd"
                                    }, null, 8, ["modelValue", "max-date"])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_103, [
                                _createElementVNode("label", null, _toDisplayString(_ctx.constants.WORK_DESCRIPTION_LABEL), 1),
                                _createElementVNode("div", _hoisted_104, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.editWorklog.comment) = $event)),
                                    placeholder: "Add work description...",
                                    rows: "3",
                                    style: {"width":"100%","padding":"10px","border":"1px solid #ddd","border-radius":"4px","resize":"vertical"}
                                  }, null, 512), [
                                    [_vModelText, _ctx.editWorklog.comment]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_105, [
                                _createElementVNode("button", {
                                  class: "v1-button-outline",
                                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.updateWorklog && _ctx.updateWorklog(...args))),
                                  disabled: _ctx.editWorklogLoading
                                }, _toDisplayString(_ctx.editWorklogLoading
                                      ? "Updating..."
                                      : "Update Work Log"), 9, _hoisted_106),
                                _createElementVNode("button", {
                                  class: "v1-button-outline-black",
                                  onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.hideEditWorklogFormHandler && _ctx.hideEditWorklogFormHandler(...args)))
                                }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                              ])
                            ])
                          ], 4),
                          _createElementVNode("div", _hoisted_107, [
                            (_ctx.issueDetail.worklogs && _ctx.issueDetail.worklogs.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.issueDetail.worklogs, (worklog) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: worklog.id,
                                      class: "jira-comments-logs-list"
                                    }, [
                                      _createElementVNode("div", _hoisted_109, [
                                        _createElementVNode("div", _hoisted_110, [
                                          _createElementVNode("div", _hoisted_111, [
                                            _createElementVNode("img", {
                                              src: worklog.author?.avatarUrls?.['48x48'] || '@/assets/lems-v1/images/team-members/ashok.jpg',
                                              alt: ""
                                            }, null, 8, _hoisted_112)
                                          ]),
                                          _createElementVNode("div", _hoisted_113, [
                                            _createElementVNode("a", _hoisted_114, _toDisplayString(worklog.author?.displayName || "Unknown"), 1)
                                          ]),
                                          _createElementVNode("span", _hoisted_115, _toDisplayString(_ctx.constants.LOGGED_WORK_TEXT), 1),
                                          _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.formatDate(worklog.started)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_117, [
                                          _createElementVNode("ul", null, [
                                            _createElementVNode("li", null, [
                                              _createElementVNode("button", {
                                                class: "jira-edit-comment-btn",
                                                onClick: ($event: any) => (_ctx.editWorklogHandler(worklog)),
                                                disabled: _ctx.editWorklogLoading || _ctx.deleteWorklogLoading,
                                                title: "Edit Work Log"
                                              }, null, 8, _hoisted_118)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _createElementVNode("button", {
                                                class: "jira-delete-comment-btn",
                                                onClick: ($event: any) => (_ctx.deleteWorklogHandler(worklog)),
                                                disabled: _ctx.editWorklogLoading || _ctx.deleteWorklogLoading,
                                                title: "Delete Work Log"
                                              }, null, 8, _hoisted_119)
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_120, [
                                        _createElementVNode("label", null, _toDisplayString(_ctx.constants.TIME_SPENT_LABEL), 1),
                                        _createTextVNode(" " + _toDisplayString(worklog.timeSpent || _ctx.formatTime(worklog.timeSpentSeconds)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_121, [
                                        (worklog.comment)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              innerHTML: _ctx.replaceJiraMarkup(worklog.comment)
                                            }, null, 8, _hoisted_122))
                                          : (_openBlock(), _createElementBlock("p", _hoisted_123, "No description provided."))
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_124, [...(_cache[32] || (_cache[32] = [
                                  _createElementVNode("div", { class: "jira-comments-logs-list-text" }, [
                                    _createElementVNode("p", null, "No work logs yet.")
                                  ], -1)
                                ]))]))
                          ]),
                          _createElementVNode("div", _hoisted_125, [
                            _createElementVNode("button", _hoisted_126, _toDisplayString(_ctx.constants.LOAD_MORE_BUTTON), 1)
                          ])
                        ])
                      ])
                    ], 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_127, [
                  _createElementVNode("div", _hoisted_128, [
                    _cache[35] || (_cache[35] = _createElementVNode("h4", null, _toDisplayString("People"), -1)),
                    _createElementVNode("div", _hoisted_129, [
                      _cache[33] || (_cache[33] = _createElementVNode("h5", null, _toDisplayString("Assignee"), -1)),
                      _createElementVNode("div", _hoisted_130, [
                        _createElementVNode("div", _hoisted_131, [
                          _createElementVNode("img", {
                            src: 
                              _ctx.issueDetail.fields?.assignee?.avatarUrls?.[
                                '48x48'
                              ] || '@/assets/lems-v1/images/person.svg'
                            ,
                            alt: ""
                          }, null, 8, _hoisted_132)
                        ]),
                        _createElementVNode("div", _hoisted_133, _toDisplayString(_ctx.issueDetail.fields?.assignee?.displayName ||
                            "Unassigned"), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_134, [
                      _cache[34] || (_cache[34] = _createElementVNode("h5", null, _toDisplayString("Reporter"), -1)),
                      _createElementVNode("div", _hoisted_135, [
                        _createElementVNode("div", _hoisted_136, [
                          _createElementVNode("img", {
                            src: 
                              _ctx.issueDetail.fields?.reporter?.avatarUrls?.[
                                '48x48'
                              ] || '@/assets/lems-v1/images/person.svg'
                            ,
                            alt: ""
                          }, null, 8, _hoisted_137)
                        ]),
                        _createElementVNode("div", _hoisted_138, _toDisplayString(_ctx.issueDetail.fields?.reporter?.displayName ||
                            "Unknown"), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_139, [
                    _cache[38] || (_cache[38] = _createElementVNode("h4", null, _toDisplayString("Date"), -1)),
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _cache[36] || (_cache[36] = _createElementVNode("span", null, _toDisplayString("Created"), -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.issueDetail.fields?.created)), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _cache[37] || (_cache[37] = _createElementVNode("span", null, _toDisplayString("Updated"), -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.issueDetail.fields?.updated)), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_140, [
                    _cache[42] || (_cache[42] = _createElementVNode("h4", null, _toDisplayString("Time Tracking"), -1)),
                    _createElementVNode("div", _hoisted_141, [
                      _createElementVNode("div", _hoisted_142, [
                        _cache[39] || (_cache[39] = _createElementVNode("span", { class: "jira-time-track-status-box-top-title" }, _toDisplayString("Estimated"), -1)),
                        _createElementVNode("span", _hoisted_143, _toDisplayString(_ctx.formatTime(_ctx.issueDetail.fields?.timeestimate)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_144, [
                        _createElementVNode("div", {
                          style: _normalizeStyle({
                            width: _ctx.getEstimatedProgress() + '%',
                            backgroundColor: '#0066BB',
                          }),
                          class: "jira-time-track-status-box-progress-bar"
                        }, null, 4)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_145, [
                      _createElementVNode("div", _hoisted_146, [
                        _cache[40] || (_cache[40] = _createElementVNode("span", { class: "jira-time-track-status-box-top-title" }, _toDisplayString("Remaining"), -1)),
                        _createElementVNode("span", _hoisted_147, _toDisplayString(_ctx.formatTime(
                            _ctx.issueDetail.fields?.timeestimate -
                              _ctx.issueDetail.fields?.timespent
                          )), 1)
                      ]),
                      _createElementVNode("div", _hoisted_148, [
                        _createElementVNode("div", {
                          style: _normalizeStyle({
                            width: _ctx.getRemainingProgress() + '%',
                            backgroundColor: '#E5843A',
                          }),
                          class: "jira-time-track-status-box-progress-bar"
                        }, null, 4)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_149, [
                      _createElementVNode("div", _hoisted_150, [
                        _cache[41] || (_cache[41] = _createElementVNode("span", { class: "jira-time-track-status-box-top-title" }, _toDisplayString("Logged"), -1)),
                        _createElementVNode("span", _hoisted_151, _toDisplayString(_ctx.formatTime(_ctx.issueDetail.fields?.timespent)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_152, [
                        _createElementVNode("div", {
                          style: _normalizeStyle({
                            width: _ctx.getLoggedProgress() + '%',
                            backgroundColor: '#7FBA00',
                          }),
                          class: "jira-time-track-status-box-progress-bar"
                        }, null, 4)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_153, [
          _createVNode(_component_Issues),
          _createVNode(_component_Activity)
        ])
      ])
    ])
  ]))
}